<template>
  <FormContainer class="forgot-password__form-container">
    <div class="forgot-password__text-block">
      <h2 class="forgot-password__title">Відновлення паролю</h2>
      <p class="forgot-password__description">Не хвилюйтеся, так буває. Щоб відновити пароль, введіть адресу електронної
        пошти, за допомогою якої Ви входите в систему. На Вашу електронну адресу буде відправлено листа із
        зазначенням подальших дій</p>
    </div>
    <form class="forgot-password__form" @submit.prevent="handleSubmit">
      <LabeledTextInput
        class="forgot-password-form__input--email"
        label="Email"
        placeholder="example@email.com"
        v-model="form.email"
        :error-messages="errors.email ? [errors.email] : []"
        @input="clearError('email')"
      />
      <div class="forgot-password-form__forgot-password-button">
        <OrangeFancyButton
          class="forgot-password-form__controls--forgot-password"
          type="submit"
          :disabled="!form.email || isLoadingResetLink"
        >
          <SpinnerLoader
            v-show="isLoadingResetLink"
            class="forgot-password-form__controls--loader"
            color="#FFFFFF"
          />
          Надіслати
        </OrangeFancyButton>
      </div>
      <div class="forgot-password-form__login">
        <SmartLink
          class="forgot-password-form__link--login"
          :route="{ name: 'login' }"
        >
          Повернутися до входу
        </SmartLink>
      </div>
    </form>
  </FormContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FormContainer } from '@/shared/ui/account';
import { LabeledTextInput, OrangeFancyButton } from '@/shared/ui/form';
import { SmartLink } from '@/shared/ui/link';
import { SpinnerLoader } from '@/shared/ui/loader';

export default {
  data() {
    return {
      form: {
        email: '',
      },
      errors: {
        email: '',
      },
    };
  },
  mounted() {
    if (this.isResetLinkError) {
      this.errors.email = this.getResetLinkErrorMessage;
    }

    this.form.email = this.getResetEmail;
  },
  components: { LabeledTextInput, SpinnerLoader, FormContainer, SmartLink, OrangeFancyButton },
  computed: {
    ...mapGetters('resetLinkEmailModule', [
      'isLoadingResetLink', 'isResetLinkError', 'getResetLinkErrorMessage', 'getResetEmail',
    ]),
  },
  methods: {
    ...mapActions('resetLinkEmailModule', ['sendResetLink']),
    validateEmail(email) {
      if (!email || email.trim().length === 0) {
        return 'Email є обов\'язковим';
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        return 'Введіть коректну email адресу';
      }
      return '';
    },
    validateForm() {
      this.errors.email = this.validateEmail(this.form.email);

      return !this.errors.email;
    },
    clearError(field) {
      this.errors[field] = '';
    },
    async handleSubmit() {
      if (this.validateForm()) {
        try {
          await this.sendResetLink(this.form.email);
        } catch (_) {
          if (this.isResetLinkError) {
            this.errors.email = this.getResetLinkErrorMessage;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.forgot-password {
  &__form-container {
    margin: 170px auto 0;
    width: 600px;

    @media (max-width: 630px) {
      margin: 50px 16px 0;
      width: auto;
    }
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 36px;
    font-weight: 400;
    color: #0C1421;
    text-align: center;
    margin-bottom: 16px;

    @media (max-width: 630px) {
      font-size: 24px;
    }
  }

  &__description {
    font-size: 18px;
    font-weight: 400;
    color: #313957;
    text-align: center;

    @media (max-width: 630px) {
      font-size: 14px;
    }
  }
}

.forgot-password-form {
  &__link {
    &--login {
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      font-weight: 400;
      color: #6171E4;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__input {
    &--email {
      margin-bottom: 16px;
    }
  }

  &__forgot-password-button {
    margin-bottom: 16px;

    &__error-text {
      font-family: "Inter", sans-serif;
      font-size: 12px;
      color: #f00;
      margin-top: 4px;
      margin-bottom: 12px;
    }
  }

  &__login {
    display: flex;
    justify-content: center;
  }

  &__controls {
    &--loader {
      margin-right: 12px;
    }
  }
}

::v-deep .input-label,
.input-label {
  position: relative;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #494E53;
  margin-bottom: 8px;
}

::v-deep .input-text,
.input-text {
  position: relative !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 22px !important;
  font-weight: 400 !important;
  background-color: #EBF2FF !important;
  width: 515px !important;
  border-radius: 16px !important;
  border: none !important;
  color: #494E53 !important;
  padding: 16px 24px !important;

  @media (max-width: 1300px) {
    width: 100% !important;
  }

  &::placeholder {
    color: #8E9DB7 !important;
  }

  &--has-error {
    border: 2px solid #FF3B30 !important;
  }
}

::v-deep .orange-fancy-button__content {
  display: flex;
  justify-content: center;
}
</style>
